import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  makeStyles,
} from "@material-ui/core";

import moment from 'moment';
import { SIREN_CONFIG } from "config.js";
import { connect } from 'react-redux';
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";


const DeviceErrorUpdateForm = (props) => {
  const { className, user, history, onErrorDeviceInfo } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const facility_id = useSelector((store) => store.user.facility_id);

  const handleSubmit = (event, values) => {
    event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/device/updateOnErrorDevice`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        rowId: onErrorDeviceInfo.rowId,
        deviceId: onErrorDeviceInfo.deviceId,
        action_taken: values.action_taken,
        action_timestamp: values.action_timestamp,
        action_user: values.action_user
      }),
    })
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      if (responseData.resultCode === "000") {
        alert(formatMessage({id:'update_successful'}));

        setTimeout(() => {
          history.goBack();
        }, 500);
      } else {
        //에러
        console.log(responseData);
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
      }
    })
    .catch((error) => {
      console.error(error);
      alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
    });
      // .then((response) => {
      //   console.log(response);
      //   if (response.status == 200){
      //     // alert("업데이트에 성공했습니다.");
      //     alert(formatMessage({id:'update_successful'}));

      //     setTimeout(() => {
      //       history.goBack();
      //     }, 500);
      //   } else {
      //     // alert(`업데이트에 실패했습니다.\n${responseData.resultMessage}`);
      //     alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
      //   }

      // });

  };


  const handleBack = () => {
    history.goBack();
  };


  return (
    <div>
    <Formik
      initialValues={{
        rowId: onErrorDeviceInfo.rowId,
        deviceId: onErrorDeviceInfo.deviceId,
        roomName: onErrorDeviceInfo.roomName || "",
        installed_pos_detail: onErrorDeviceInfo.installed_pos_detail || "",
        errorTime: onErrorDeviceInfo.errorTime,
        action_taken: onErrorDeviceInfo.action_taken,
        action_timestamp: onErrorDeviceInfo.action_timestamp || moment().format('YY.MM.DD HH:mm'), //default로 현재시각
        action_user: onErrorDeviceInfo.action_user || user.admin_name, //로그인한 관리자 이름을 default로 표시
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.root, className)}
          onSubmit={(e) => handleSubmit(e, values)}
        >
          <Card>
            <CardHeader
              className={classes.card_header}
              title={formatMessage({id:'device_check_action_title'})}
              titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }}
            />

            <Divider />

            <CardContent>
              <Grid container spacing={2}>
                <Grid container item md={12} xs={12} spacing={2}>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.deviceId && errors.deviceId)}
                      fullWidth
                      helperText={touched.deviceId && errors.deviceId}
                      label={formatMessage({id:'device_sensor_id'})}
                      name="deviceId"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.deviceId}
                      variant="outlined"
                      inputProps={{ maxLength: 26 }}
                      disabled
                    />
                  </Grid>


                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.roomName && errors.roomName)}
                      fullWidth
                      helperText={touched.roomName && errors.roomName}
                      label={formatMessage({id:'room_name'})}
                      name="roomName"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.roomName}
                      variant="outlined"
                      inputProps={{ maxLength: 50 }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.installed_pos_detail && errors.installed_pos_detail)}
                      fullWidth
                      helperText={touched.installed_pos_detail && errors.installed_pos_detail}
                      label={formatMessage({id:'room_position'})}
                      name="installed_pos_detail"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.installed_pos_detail}
                      variant="outlined"
                      inputProps={{ maxLength: 50 }}
                      disabled
                    />
                  </Grid>
                </Grid>

                <Grid container item md={12} xs={12} spacing={2}>

                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(touched.errorTime && errors.errorTime)}
                      fullWidth
                      helperText={touched.errorTime && errors.errorTime}
                      label={formatMessage({id:'device_check_table_occurTime'})}
                      name="errorTime"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      value={values.errorTime}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                      disabled
                    />
                  </Grid>

                </Grid>


                <Grid item md={12} xs={12}>
                  <TextField
                    error={Boolean(touched.action_taken && errors.action_taken)}
                    fullWidth
                    helperText={touched.action_taken && errors.action_taken}
                    label={formatMessage({id:'emergency_history_action_100'})}
                    name="action_taken"
                    multiline
                    rows={10}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // required
                    value={values.action_taken}
                    variant="outlined"
                    inputProps={{ maxLength: 100 }}
                  />
                </Grid>


                <Grid container item md={12} xs={12} spacing={1}>

                  <Grid item md={6} xs={12}>
                    <TextField
                      error={Boolean(touched.action_timestamp && errors.action_timestamp)}
                      fullWidth
                      helperText={touched.action_timestamp && errors.action_timestamp}
                      label={formatMessage({id:'emergency_history_actionTime'})}
                      name="action_timestamp"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // required
                      value={values.action_timestamp}
                      variant="outlined"
                      inputProps={{ maxLength: 16 }}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      error={Boolean(touched.action_user && errors.action_user)}
                      fullWidth
                      helperText={touched.action_user && errors.action_user}
                      label={formatMessage({id:'emergency_history_actor'})}
                      name="action_user"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // required
                      value={values.action_user}
                      variant="outlined"
                      inputProps={{ maxLength: 20 }}
                    />
                  </Grid>

                </Grid>


                <Grid item md={6} xs={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    size="large"
                    disabled={isSubmitting}
                    className={classes.action}
                  >
                    <FormattedMessage id="emergency_history_act_completed" />
                  </Button>

                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleBack}
                    className={classes.action}
                  >
                    <FormattedMessage id="cancel" />
                  </Button>
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
    </div>
  );
};

DeviceErrorUpdateForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


let mapStateToProps = (state) => {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps
)(DeviceErrorUpdateForm);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
}));
